import { observer } from 'mobx-react-lite';
import { modalStore } from 'store/mobx/modal.store';

import ModalSampleType from 'components/Modals/ModalSampleType';
import ModalSampleView from 'components/Modals/ModalSampleView';
import ModalSampleEdit from 'components/Modals/ModalSampleEdit';

const MODALS = {
  sampleType: ModalSampleType,
  sampleView: ModalSampleView,
  sampleEdit: ModalSampleEdit,
};

const ModalProvider = observer(() => {
  const current = modalStore.activeModal;
  const ModalComponent = current ? MODALS[current.name] : null;

  if (!ModalComponent) return null;

  return <ModalComponent {...current.props} onClose={() => modalStore.closeModal(current.name)} />;
});

export default ModalProvider;
